import type { LowLevelClientOptions } from '../lowlevel-client/interfaces';

export enum WebSocketWatchdogEventType {
  ConnectionRestored = 'ConnectionRestored',
  ConnectionLost = 'ConnectionLost',
}

export type WebSocketWatchdogEvent = {
  readonly eventType: WebSocketWatchdogEventType;
};

export const NOTIFY_SUBJECT_KEY = 'subject' as const;

/**
 * AppSyncWebSocketLink will automatically resubscribe after the socket is reconnected and ACKed if truthy.
 */
export const RESUBSCRIBE_ON_RECONNECT_KEY =
  'resubscribeOnReconnect' as const satisfies keyof LowLevelClientOptions;

export interface NotifyWebSocketWatchdogEventSubject {
  next(value: WebSocketWatchdogEvent): void;
}

export function isNotifyWebSocketWatchdogEventSubject(
  subject: unknown,
): subject is NotifyWebSocketWatchdogEventSubject {
  return typeof (subject as { next?: unknown })?.next === 'function';
}
